import * as tslib_1 from "tslib";
import { HttpParams } from '@angular/common/http';
import { BaseProvider } from './base-provider';
import { Subject } from 'rxjs';
import * as moment from 'moment';
import { ProfileSelectionModalComponent } from '../components/profile-selection-modal/profile-selection-modal.component';
import * as i0 from "@angular/core";
import * as i1 from "@angular/router";
import * as i2 from "./globals.service";
import * as i3 from "./cleanup.service";
import * as i4 from "@angular/common/http";
import * as i5 from "./ls-helper.service";
import * as i6 from "@ngx-translate/core";
import * as i7 from "@angular/material/dialog";
export class AuthService extends BaseProvider {
    constructor(router, globals, cleanupService, http, ls, translate, dialog) {
        super();
        this.router = router;
        this.globals = globals;
        this.cleanupService = cleanupService;
        this.http = http;
        this.ls = ls;
        this.translate = translate;
        this.dialog = dialog;
        this.sessionActive = false;
        this.langKey = 'SELECTED_LANGUAGE';
        this.userProfile = {
            roles: [],
            userProfile: {
                Name: '',
                SecondLastName: '',
                FileName: 'assets/images/avatars/profile.jpg'
            },
            email: '',
        };
        this.users = [];
        this.itemToEdit = {};
        this.isNew = false;
        this.localUserActionOccured = new Subject();
        this.selectedProfile = null;
        this.menuItems = [];
        // console.log(this.authItems);
    }
    // Add getter for currentUser
    get currentUser() {
        return {
            name: this.userProfile.email
        };
    }
    get userActionOccured() { return this.localUserActionOccured.asObservable(); }
    notifyUserAction() {
        this.localUserActionOccured.next();
    }
    loginUser() {
        console.log('user login');
    }
    logOutUser() {
        this.logout();
    }
    setInitialAppLanguage() {
        let lang = this.ls.get(this.langKey);
        if (lang == null) {
            lang = 'es';
            this.translate.setDefaultLang(lang);
            this.ls.set(this.langKey, lang);
            console.log('lang');
            console.log(lang);
        }
        this.setLanguage(lang);
    }
    setLanguage(lng) {
        this.translate.use(lng);
        this.ls.set(this.langKey, lng);
    }
    register(data) {
        return new Promise((resolve, reject) => {
            this.url = this.globals.dataUrl + 'account/register';
            this.http
                .post(this.url, data)
                .subscribe((data) => {
                if (!data.Success) {
                    reject(data.Message);
                }
                else {
                    resolve(data);
                }
            }, err => {
                reject(err);
            });
        });
    }
    login(data) {
        const body = 'grant_type=' + data.grant_type +
            '&username=' + data.username +
            '&password=' + data.password;
        return new Promise((resolve, reject) => {
            this.url = this.globals.dataUrl + 'token';
            this.http
                .post(this.url, body)
                .subscribe((data) => {
                // debugger;
                this.globals.loginData = data;
                this.ls.set('loginData', this.globals.loginData);
                this.sessionActive = true;
                this.setSession(this.globals.loginData);
                this.getProfile().then((profile) => {
                    this.ls.set('userId', profile.userId);
                    resolve(data);
                });
            }, err => {
                // debugger;
                this.setError(this.translate.instant('login.serverError'));
                reject(err);
            });
        });
    }
    logout() {
        this.ls.set('id_token', null);
        this.ls.set('expires_at', null);
        this.sessionActive = false;
        this.userProfile = [];
        this.selectedProfile = null;
        this.menuItems = [];
        this.ls.set('userProfile', this.userProfile);
        this.ls.set('selectedProfile', null);
        this.ls.set('menuItems', this.menuItems);
        this.cleanupService.doCleanup();
        // this.router.events.subscribe((val:any) => {
        // if(val.url == '/login-admin'){
        // if(this.hasPolicy("CanAttendProcesses")){
        // this.router.navigate([`/login-admin`]);
        // }
        // else{
        this.router.navigate([`/login`]);
        // }
        // });
    }
    logOutStay() {
        this.ls.set('id_token', null);
        this.ls.set('expires_at', null);
        this.sessionActive = false;
        this.userProfile = [];
        this.ls.set('userProfile', this.userProfile);
        this.cleanupService.doCleanup();
    }
    requestPasswordEmail(data) {
        return new Promise((resolve, reject) => {
            this.url = this.globals.dataUrl + 'account/requestPasswordChange';
            this.http
                .post(this.url, data)
                .subscribe((data) => {
                if (!data.Success) {
                    reject(data.Message);
                }
                else {
                    resolve(data);
                }
            }, err => {
                reject(err);
            });
        });
    }
    changePassword(data) {
        return new Promise((resolve, reject) => {
            this.url = this.globals.dataUrl + 'account/changePassword';
            this.http
                .post(this.url, data)
                .subscribe((data) => {
                if (!data.Success) {
                    reject(data.Message);
                }
                else {
                    resolve(data);
                }
            }, err => {
                reject(err);
            });
        });
    }
    changePasswordAdmin(newPassword, userId) {
        return new Promise((resolve, reject) => {
            this.url = this.globals.dataUrl + 'adminUser' + "/password/" + userId;
            this.http
                .post(this.url, {
                Password: newPassword
            })
                .subscribe((data) => {
                resolve(data);
            }, err => { reject(err); });
        });
    }
    getToken() {
        return this.ls.get('id_token');
    }
    setSession(authResult) {
        const expiresAt = moment().add(authResult.expires_in, 'second');
        this.ls.set('id_token', authResult.access_token);
        this.ls.set('expires_at', JSON.stringify(expiresAt.valueOf()));
    }
    getRole(cb) {
        this.url = this.globals.dataUrl + 'account/role';
        const loginData = this.ls.get('loginData');
        this.http.get(this.url)
            .subscribe(data => {
            if (typeof cb === 'function') {
                cb(data[0]);
            }
        });
    }
    getCurrentRoles() {
        const profile = this.ls.get('userProfile');
        let roles = [];
        if (profile) {
            roles = profile.roles;
        }
        return roles;
    }
    getUserDisplayName() {
        let displayName = '';
        try {
            if (this.userProfile.userProfile) {
                if (this.userProfile.userProfile.FirstName &&
                    this.userProfile.userProfile.FirstLastName) {
                    displayName = this.userProfile.userProfile.FirstName + ' ' +
                        this.userProfile.userProfile.FirstLastName;
                }
                else {
                    displayName = this.userProfile.email;
                }
            }
            else {
                displayName = this.userProfile.email;
            }
        }
        catch (e) { }
        return displayName;
    }
    getProfileImage() {
        let displayFileName = '';
        try {
            if (this.userProfile.userProfile) {
                if (this.userProfile.userProfile.FileName) {
                    displayFileName = this.globals.sa + '/' + this.userProfile.userProfile.FileName;
                }
                else {
                    displayFileName = 'assets/images/avatars/profile.jpg';
                }
            }
            else {
                displayFileName = 'assets/images/avatars/profile.jpg';
            }
        }
        catch (e) { }
        return displayFileName;
    }
    getProfile() {
        return new Promise((resolve, reject) => {
            this.url = this.globals.dataUrl + 'account/details';
            this.http
                .get(this.url)
                .subscribe((data) => {
                this.userProfile = data.Data;
                this.ls.set('userProfile', this.userProfile);
                resolve(data.Data);
            }, err => { reject(err); });
        });
    }
    getFile(fileName) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const queryParams = new HttpParams()
                .set('fileName', fileName.toString());
            return yield new Promise((resolve, reject) => {
                this.url = `${this.globals.dataUrl}account/signature`;
                this.http
                    .get(this.url, { responseType: 'arraybuffer', params: queryParams })
                    .subscribe((data) => {
                    const blob = new Blob([data], { type: 'image/png' });
                    const url = window.URL.createObjectURL(blob);
                    resolve(url);
                }, err => { reject(err); });
            });
        });
    }
    getProfileFromLs() {
        return this.ls.get('userProfile');
    }
    isLoggedIn() {
        this.sessionActive = moment().isBefore(this.getExpiration());
        return this.sessionActive;
    }
    getExpiration() {
        const expiration = localStorage.getItem('expires_at');
        const expiresAt = JSON.parse(expiration);
        return moment(parseInt(expiresAt));
    }
    loadUserData() {
        if (this.isLoggedIn()) {
            this.userProfile = this.ls.get('userProfile');
            // this.filterMenuItems();
        }
        else {
            // this.filterAuthItems();
        }
        // this.lookupService.filterHomeItems();
    }
    hasPolicy(testName) {
        let hasPolicy = false;
        const profile = this.ls.get('userProfile');
        if (profile.policies) {
            hasPolicy = profile.policies.find((policy) => {
                return policy.PolicyName === testName;
            });
        }
        return hasPolicy;
    }
    hasPolicyBool(testName) {
        const policy = this.hasPolicy(testName);
        return policy;
    }
    checkPolicyIfLoggedIn(testName) {
        if (!this.isLoggedIn()) {
            return true;
        }
        else {
            return this.hasPolicyBool(testName);
        }
    }
    hasRole(roleName) {
        let hasRole = false;
        const profile = this.ls.get('userProfile');
        if (profile) {
            if (profile.roles) {
                hasRole = profile.roles.find((role) => {
                    return role === roleName;
                });
            }
        }
        return hasRole;
    }
    /**
     * Región asignada al usuario interno (inspectores). El API puede exponer cualquiera de estas propiedades en account/details.
     * Si no hay valor, el front no fuerza regionId en la búsqueda (el backend puede filtrar por sesión).
     */
    getUserAssignedRegionId() {
        const p = this.ls.get('userProfile') || this.userProfile;
        if (!p) {
            return null;
        }
        const raw = p.RegionId != null && p.RegionId !== '' ? p.RegionId :
            p.regionId != null && p.regionId !== '' ? p.regionId :
                p.AssignedRegionId != null && p.AssignedRegionId !== '' ? p.AssignedRegionId :
                    p.assignedRegionId != null && p.assignedRegionId !== '' ? p.assignedRegionId :
                        p.UserRegionId != null && p.UserRegionId !== '' ? p.UserRegionId :
                            p.userRegionId != null && p.userRegionId !== '' ? p.userRegionId :
                                null;
        if (raw == null || raw === '') {
            return null;
        }
        const n = Number(raw);
        return Number.isFinite(n) && n > 0 ? n : null;
    }
    searchUsers(params) {
        return new Promise((resolve, reject) => {
            this.url = this.globals.dataUrl + 'adminUser' +
                '/term/' + params.term +
                '/page/' + params.pageNumber +
                '/size/' + params.pageSize +
                '/category/' + params.category +
                '/active/' + params.isActive;
            this.http
                .get(this.url)
                .subscribe((data) => {
                this.users = data.Data;
                resolve(data.Data);
            }, err => { reject(err); });
        });
    }
    getById(id) {
        return new Promise((resolve, reject) => {
            this.url = this.globals.dataUrl + 'adminUser' + '/' + id;
            var loginData = this.ls.get('loginData');
            this.http.get(this.url)
                .subscribe((data) => {
                this.itemToEdit = data.Data;
                resolve(this.itemToEdit);
            }, err => { reject(err); });
        });
    }
    /**
     * Generar codigo y envio de email de 2FA
     */
    generateTwoFactor(data) {
        return new Promise((resolve, reject) => {
            this.url = this.globals.dataUrl + 'account/generateTwoFactor';
            this.http
                .post(this.url, data)
                .subscribe((data) => {
                if (!data.Success) {
                    reject(data.Message);
                }
                else {
                    resolve(data);
                }
            }, err => {
                reject(err);
            });
        });
    }
    /**
     * Verificar token de 2FA
     */
    verifyTwoFactorToken(data) {
        return new Promise((resolve, reject) => {
            this.url = this.globals.dataUrl + 'account/verifyTwoFactorToken';
            this.http
                .post(this.url, data)
                .subscribe((data) => {
                if (!data.Success) {
                    reject(data.Message);
                }
                else {
                    resolve(data);
                }
            }, err => {
                reject(err);
            });
        });
    }
    RegisterAndValidate2FA(data) {
        return new Promise((resolve, reject) => {
            this.url = this.globals.dataUrl + 'account/registerAndValidateTwoFactor';
            this.http
                .post(this.url, data)
                .subscribe((data) => {
                if (!data.Success) {
                    reject(data.Message);
                }
                else {
                    resolve(data);
                }
            }, err => {
                reject(err);
            });
        });
    }
    confirmEmail(data) {
        return new Promise((resolve, reject) => {
            this.url = this.globals.dataUrl + 'account/confirmEmail';
            this.http
                .post(this.url, data)
                .subscribe((data) => {
                if (!data.Success) {
                    reject(data.Message);
                }
                else {
                    resolve(data);
                }
            }, err => {
                reject(err);
            });
        });
    }
    resendEmailConfirm(data) {
        return new Promise((resolve, reject) => {
            this.url = this.globals.dataUrl + 'account/resendEmailConfirm';
            this.http
                .post(this.url, data)
                .subscribe((data) => {
                if (!data.Success) {
                    reject(data.Message);
                }
                else {
                    resolve(data);
                }
            }, err => {
                reject(err);
            });
        });
    }
    /**
   * Abre el modal para seleccionar un perfil médico
   */
    openProfileSelectionModal(disableClose = false) {
        // Obtener el perfil actual (si existe)
        const currentProfileData = localStorage.getItem('selectedProfile');
        let currentProfile = null;
        if (currentProfileData) {
            try {
                currentProfile = JSON.parse(currentProfileData);
            }
            catch (error) {
                console.error('Error al leer el perfil actual:', error);
            }
        }
        // Crear una configuración personalizada para el diálogo
        const dialogConfig = {
            width: '400px',
            maxWidth: '80vw',
            maxHeight: '80vh',
            disableClose: disableClose,
            autoFocus: true,
            panelClass: ['no-padding-dialog'],
            data: { currentProfile }
        };
        // Abrir el modal y pasar el perfil actual como data
        const dialogRef = this.dialog.open(ProfileSelectionModalComponent, dialogConfig);
        dialogRef.afterClosed().subscribe(selectedProfile => {
            if (selectedProfile) {
                const isNewProfile = !currentProfile ||
                    (currentProfile.Id || currentProfile.id) !== (selectedProfile.Id || selectedProfile.id);
                // Guardar el perfil seleccionado en localStorage
                this.setSelectedProfile(selectedProfile);
                localStorage.setItem('selectedProfile', JSON.stringify(selectedProfile));
                // Mostrar notificación de perfil cambiado
                if (isNewProfile) {
                    this.showLoader();
                    console.log('Perfil cambiado a:', selectedProfile.Name);
                    window.dispatchEvent(new CustomEvent('profileChanged', {
                        detail: { profileId: selectedProfile.Id || selectedProfile.id }
                    }));
                    this.getMenuItemsForProfile(selectedProfile.Id).then((data) => {
                        this.setMenuItems(data.modules);
                        let urlRedirect = '/';
                        if (data.modules.length > 0) {
                            if (data.modules[0].Children.length > 0) {
                                urlRedirect = data.modules[0].Children[0].Route;
                            }
                        }
                        this.hideLoader();
                        if (this.router.url.includes(urlRedirect)) {
                            window.location.reload();
                        }
                        else {
                            this.router.navigate([urlRedirect]);
                        }
                        // Ocultar loader después de un tiempo prudencial
                        setTimeout(() => {
                        }, 700);
                    });
                }
            }
        });
    }
    getMenuItemsForProfile(id) {
        return new Promise((resolve, reject) => {
            this.url = `${this.globals.dataUrl}/profileType/${id}/modules`;
            this.http.get(this.url)
                .subscribe((data) => {
                resolve(data.Data);
            }, err => {
                reject(err);
            });
        });
    }
    /**
     * Muestra el loader a pantalla completa
     */
    showLoader() {
        document.body.style.overflow = 'hidden';
        // Crear el elemento loader si no existe
        if (!document.getElementById('full-screen-loader')) {
            const loaderElement = document.createElement('div');
            loaderElement.id = 'full-screen-loader';
            loaderElement.innerHTML = `
        <div class="loader-container">
          <div class="spinner-container">
            <div class="loader-spinner"></div>
          </div>
          <div class="loader-text">Cargando información del perfil...</div>
        </div>
      `;
            // Añadir estilos inline para el loader
            loaderElement.style.position = 'fixed';
            loaderElement.style.top = '0';
            loaderElement.style.left = '0';
            loaderElement.style.width = '100%';
            loaderElement.style.height = '100%';
            loaderElement.style.backgroundColor = 'rgba(0, 0, 0, 0.5)';
            loaderElement.style.zIndex = '9999';
            loaderElement.style.display = 'flex';
            loaderElement.style.justifyContent = 'center';
            loaderElement.style.alignItems = 'center';
            loaderElement.style.color = 'white';
            loaderElement.style.fontFamily = 'Poppins, sans-serif';
            // Estilos para el contenedor interno
            const style = document.createElement('style');
            style.innerHTML = `
        .loader-container {
          display: flex;
          flex-direction: column;
          align-items: center;
          background-color: rgba(19, 47, 92, 0.9);
          padding: 30px;
          border-radius: 10px;
          box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
        }
        .spinner-container {
          margin-bottom: 20px;
        }
        .loader-spinner {
          border: 5px solid rgba(255, 255, 255, 0.3);
          border-radius: 50%;
          border-top: 5px solid #ffffff;
          width: 50px;
          height: 50px;
          animation: spin 1s linear infinite;
        }
        .loader-text {
          font-size: 16px;
          font-weight: 500;
        }
        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
      `;
            document.head.appendChild(style);
            document.body.appendChild(loaderElement);
        }
        else {
            document.getElementById('full-screen-loader').style.display = 'flex';
        }
    }
    /**
     * Oculta el loader a pantalla completa
     */
    hideLoader() {
        document.body.style.overflow = '';
        const loaderElement = document.getElementById('full-screen-loader');
        if (loaderElement) {
            loaderElement.style.display = 'none';
        }
    }
    setSelectedProfile(profile) {
        localStorage.setItem('selectedProfile', JSON.stringify(profile));
        this.selectedProfile = profile;
    }
    getSelectedProfile() {
        const selectedProfile = JSON.parse(localStorage.getItem('selectedProfile'));
        this.selectedProfile = selectedProfile;
        return this.selectedProfile;
    }
    setMenuItems(menu) {
        localStorage.setItem('menuItems', JSON.stringify(menu));
        this.menuItems = menu;
    }
    getMenuItems() {
        const menuItems = JSON.parse(localStorage.getItem('menuItems'));
        this.menuItems = menuItems;
        return this.menuItems;
    }
    updateSignature(signatureData) {
        return new Promise((resolve, reject) => {
            this.url = `${this.globals.dataUrl}account/signature`;
            this.http
                .put(this.url, { signature: signatureData })
                .subscribe((data) => {
                resolve(data);
            }, err => { reject(err); });
        });
    }
    getSignature(fileName) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const queryParams = new HttpParams()
                .set('fileName', fileName.toString());
            return yield new Promise((resolve, reject) => {
                this.url = `${this.globals.dataUrl}account/signature`;
                this.http
                    .get(this.url, { responseType: 'arraybuffer', params: queryParams })
                    .subscribe((data) => {
                    const blob = new Blob([data], { type: 'image/png' });
                    const url = window.URL.createObjectURL(blob);
                    resolve(url);
                }, err => { reject(err); });
            });
        });
    }
    deleteSignature() {
        return new Promise((resolve, reject) => {
            this.url = `${this.globals.dataUrl}account/signature`;
            this.http
                .delete(this.url)
                .subscribe((data) => {
                resolve(data);
            }, err => { reject(err); });
        });
    }
    getFileByFileName(fileName, returnUrl = false) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const queryParams = new HttpParams()
                .set('fileName', fileName.toString());
            return yield new Promise((resolve, reject) => {
                this.url = `${this.globals.dataUrl}account/file`;
                this.http
                    .get(this.url, { responseType: 'arraybuffer', params: queryParams })
                    .subscribe((data) => {
                    if (returnUrl) {
                        const blob = new Blob([data], { type: 'image/jpeg' });
                        const url = window.URL.createObjectURL(blob);
                        resolve(url);
                    }
                    else {
                        const base64String = `data:image/jpeg;base64,${this.arrayBufferToBase64(data)}`;
                        resolve(base64String);
                    }
                }, err => { reject(err); });
            });
        });
    }
    arrayBufferToBase64(buffer) {
        let binary = '';
        const bytes = new Uint8Array(buffer);
        const len = bytes.byteLength;
        for (let i = 0; i < len; i++) {
            binary += String.fromCharCode(bytes[i]);
        }
        return btoa(binary);
    }
}
AuthService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function AuthService_Factory() { return new AuthService(i0.ɵɵinject(i1.Router), i0.ɵɵinject(i2.GlobalsService), i0.ɵɵinject(i3.CleanupService), i0.ɵɵinject(i4.HttpClient), i0.ɵɵinject(i5.LsHelperService), i0.ɵɵinject(i6.TranslateService), i0.ɵɵinject(i7.MatDialog)); }, token: AuthService, providedIn: "root" });
